__turbopack_context__.v({
  "bannerStrip": "BannerStrip-module-scss-module__F9GC9a__bannerStrip",
  "buttonUnderline": "BannerStrip-module-scss-module__F9GC9a__buttonUnderline",
  "ctaContainer": "BannerStrip-module-scss-module__F9GC9a__ctaContainer",
  "icon": "BannerStrip-module-scss-module__F9GC9a__icon",
  "iconTextContainer": "BannerStrip-module-scss-module__F9GC9a__iconTextContainer",
  "iconWrapper": "BannerStrip-module-scss-module__F9GC9a__iconWrapper",
  "light": "BannerStrip-module-scss-module__F9GC9a__light",
  "linkText": "BannerStrip-module-scss-module__F9GC9a__linkText",
  "membership": "BannerStrip-module-scss-module__F9GC9a__membership",
  "subtitle": "BannerStrip-module-scss-module__F9GC9a__subtitle",
  "textContainer": "BannerStrip-module-scss-module__F9GC9a__textContainer",
  "title": "BannerStrip-module-scss-module__F9GC9a__title",
});
